import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/output.css';
import App from './MainView';
import reportWebVitals from './testing/reportWebVitals';
import Header from './Header';
import RentalView from './RentalView';
import MirceaView from './MirceaView';

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "Rental",
    element: <RentalView />,
  },
  {
    path: "Mircea",
    element: <MirceaView />,
  },
  {
    path: "*",
    element: <App />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Header></Header>
    <RouterProvider router={router} />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
